import { combineReducers } from 'redux';

import PostReducer from './posts/postReducer';
import { alertReducer } from './alert/alertReducer';
import { userReducer } from './account/userReducer';
import { loadingReducer } from './loading/loadingReducer';
import { orderStatusReducer } from './orderStatus/orderStatusReducer';
import { stockStatusReducer } from './stockStatus/stockStatusReducer';
import { shipmentStatusReducer } from './shipmentStatus/shipmentStatusReducer';
import { materialReducer } from './material/materialReducer';
import {yarnReducer} from './yarn/yarnReducer';
import { threadReducer } from './thread/threadReducer';
import { weaveReducer } from './weave/weaveReducer';  
import { colorReducer } from './color/colorReducer';
import { unitReducer } from './unit/unitReducer';
import { compositionReducer } from './composition/compositionReducer';
import { weaveColorReducer } from './weavecolor/weaveColorReducer';
import { weaveFactorReducer } from './weavefactor/weaveFactorReducer';
import { currencyReducer } from './currency/currencyReducer';
import { weaveTypeReducer } from './weaveType/weaveTypeReducer';
import { usersReducer } from './users/usersReducer';
import { customerReducer } from './customer/customerReducer';
import { supplierReducer } from './supplier/supplierReducer';
import { shipmentReducer } from './shipment/shipmentReducer';
import { stockReducer } from './stock/stockReducer';
import { orderReducer } from './order/orderReducer';
import { productReducer } from './product/productReducer';
import { supplierTypeReducer } from './supplierType/supplierTypeReducer';
import { sampleReducer } from './sample/sampleReducer';
import { orderSupplierReducer } from './orderSupplier/orderSupplierReducer';

const sidebarInitialState = {
  sidebarShow: window.innerWidth >= 768,
  sidebarUnfoldable: false
};

const sidebarReducer = (state = sidebarInitialState, action) => {
  switch (action.type) {
    case 'set':
      return {
        ...state,
        ...(action.sidebarShow !== undefined && { sidebarShow: action.sidebarShow }),
        ...(action.sidebarUnfoldable !== undefined && 
          { sidebarUnfoldable: action.sidebarUnfoldable })
      };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  PostReducer,
  alertReducer,
  userReducer,
  loadingReducer,
  orderStatusReducer,
  stockStatusReducer,
  shipmentStatusReducer,
  materialReducer,
  yarnReducer,
  threadReducer,
  weaveReducer,
  color: colorReducer,
  colorReducer: colorReducer,
  unitReducer,
  compositionReducer,
  weaveColorReducer,
  weaveFactorReducer,
  currencyReducer,
  weaveTypeReducer,
  usersReducer,
  customerReducer,
  supplierReducer,
  shipmentReducer,
  stockReducer,
  orderReducer,
  productReducer,
  supplierTypeReducer,
  sampleReducer,
  orderSupplierReducer,
  sidebar: sidebarReducer
});

export default rootReducer;
